function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_42916_4775)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.7812 8.4375C11.5579 8.4375 12.1875 7.8079 12.1875 7.03125C12.1875 6.2546 11.5579 5.625 10.7812 5.625C10.0046 5.625 9.375 6.2546 9.375 7.03125C9.375 7.8079 10.0046 8.4375 10.7812 8.4375Z",
  fill: "#44565A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.2188 8.4375C19.9954 8.4375 20.625 7.8079 20.625 7.03125C20.625 6.2546 19.9954 5.625 19.2188 5.625C18.4421 5.625 17.8125 6.2546 17.8125 7.03125C17.8125 7.8079 18.4421 8.4375 19.2188 8.4375Z",
  fill: "#44565A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7812 16.4062C11.5579 16.4062 12.1875 15.7767 12.1875 15C12.1875 14.2233 11.5579 13.5938 10.7812 13.5938C10.0046 13.5938 9.375 14.2233 9.375 15C9.375 15.7767 10.0046 16.4062 10.7812 16.4062Z",
  fill: "#44565A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.2188 16.4062C19.9954 16.4062 20.625 15.7767 20.625 15C20.625 14.2233 19.9954 13.5938 19.2188 13.5938C18.4421 13.5938 17.8125 14.2233 17.8125 15C17.8125 15.7767 18.4421 16.4062 19.2188 16.4062Z",
  fill: "#44565A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7812 24.375C11.5579 24.375 12.1875 23.7454 12.1875 22.9688C12.1875 22.1921 11.5579 21.5625 10.7812 21.5625C10.0046 21.5625 9.375 22.1921 9.375 22.9688C9.375 23.7454 10.0046 24.375 10.7812 24.375Z",
  fill: "#44565A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.2188 24.375C19.9954 24.375 20.625 23.7454 20.625 22.9688C20.625 22.1921 19.9954 21.5625 19.2188 21.5625C18.4421 21.5625 17.8125 22.1921 17.8125 22.9688C17.8125 23.7454 18.4421 24.375 19.2188 24.375Z",
  fill: "#44565A"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_42916_4775"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "white"
})));
function SvgDraggable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.ba2d16c4.svg";
export { ForwardRef as ReactComponent };